export const TID = {
  // Landing
  loginBtn: "landing-login-btn",
  ctaGetStarted: "landing-cta-get-started",
  // Auth
  googleLoginBtn: "google-login-btn",
  // Nav
  navHome: "nav-home",
  navSamples: "nav-samples",
  navVoice: "nav-voice",
  navWrite: "nav-write",
  navLogout: "nav-logout",
  // Samples
  sampleTitleInput: "sample-title-input",
  sampleContentInput: "sample-content-input",
  sampleSubmitBtn: "sample-submit-btn",
  sampleUploadInput: "sample-upload-input",
  sampleUploadBtn: "sample-upload-btn",
  sampleScanInput: "sample-scan-input",
  sampleScanBtn: "sample-scan-btn",
  sampleScanReviewInput: "sample-scan-review-input",
  sampleScanSaveBtn: "sample-scan-save-btn",
  sampleAudioRecordBtn: "sample-audio-record-btn",
  sampleAudioStopBtn: "sample-audio-stop-btn",
  sampleAudioUploadBtn: "sample-audio-upload-btn",
  sampleAudioUploadInput: "sample-audio-upload-input",
  sampleAudioReviewInput: "sample-audio-review-input",
  sampleAudioSaveBtn: "sample-audio-save-btn",
  tabPaste: "tab-paste",
  tabFile: "tab-file",
  tabScan: "tab-scan",
  tabAudio: "tab-audio",
  sampleListItem: (id) => `sample-item-${id}`,
  sampleDeleteBtn: (id) => `sample-delete-${id}`,
  sampleCategorySelect: (id) => `sample-category-select-${id}`,
  categorySelector: "category-selector",
  // Voice
  analyzeVoiceBtn: "analyze-voice-btn",
  voiceProfileCard: "voice-profile-card",
  // Write
  writePromptInput: "write-prompt-input",
  writeModelSelect: "write-model-select",
  writeModeSelect: "write-mode-select",
  writeLengthSelect: "write-length-select",
  writeHumanizeSelect: "write-humanize-select",
  writeGenerateBtn: "write-generate-btn",
  writeOutput: "write-output",
  writeCopyBtn: "write-copy-btn",
  writeRegenerateBtn: "write-regenerate-btn",
  writeHumanizeMoreBtn: "write-humanize-more-btn",
  writeDetectBtn: "write-detect-btn",
  writeDetectionResult: "write-detection-result",
  writeSaveAsSampleBtn: "write-save-as-sample-btn",
  writeSaveAsSampleTitleInput: "write-save-as-sample-title-input",
  writeSaveAsSampleConfirm: "write-save-as-sample-confirm",
  writeDownloadBtn: "write-download-btn",
  writePdfBtn: "write-pdf-btn",
  writeSharePdfBtn: "write-share-pdf-btn",
  writeEmailBtn: "write-email-btn",
  // Footer
  footerContactLink: "footer-contact-link",
};
